import { Injectable, Pipe, PipeTransform } from '@angular/core';
// Define a type for the pronouns
interface Pronouns {
  he_she: string;
  his_her: string;
  him_her: string;
}

@Pipe({
  name: 'genderReplace',
  standalone: true, // Marking the pipe as standalone
})
@Injectable({ providedIn: 'root' })
export class GenderReplacePipe implements PipeTransform {
  // Define the transform function with proper types
  transform(value: string, name: string, gender: string): string {
    if (!value) return value;

    // Pronouns mapping for different genders
    const pronounMapping: {
      [key in 'Male' | 'Female' | 'Not Specified' as string]: Pronouns;
    } = {
      Male: { he_she: 'he', his_her: 'his', him_her: 'him' },
      Female: { he_she: 'she', his_her: 'her', him_her: 'her' },
      'Not Specified': { he_she: 'they', his_her: 'their', him_her: 'them' },
    };

    // Get the corresponding pronouns for the given gender
    const pronouns = pronounMapping[gender];

    // Replace the placeholders in the string with the appropriate name and pronouns
    return value
      .replace(/\(name\)/g, name)
      .replace(/\(pronoun_he-she\)/g, pronouns.he_she)
      .replace(/\(pronoun_his-her\)/g, pronouns.his_her)
      .replace(/\(pronoun_him-her\)/g, pronouns.him_her);
  }
}
